import React, { useEffect, useContext, useState } from "react";
import { Paper, Pagination, Typography, Box } from "@mui/material";
import IndustriesTable from "./Table";
import CircularProgress from "@mui/material/CircularProgress";
import IndustriesView from "./IndustriesView";
import { industryContext } from "../../contexts/IndustryContext";
import IndustryEdit from "./IndustryEdit";

export default function SmsLogs() {
  const [page, setPage] = useState(1);
  const { industryCount, handleSearchIndustry, loading } =
    useContext(industryContext);

  useEffect(() => {
    handleSearchIndustry({ page });
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
    handleSearchIndustry({  page : value});
  };

  return (
    <div>
      <Paper
        sx={{
          textAlign: "center",
          padding: "5px",
        }}
      >
        <Box sx={{ justifyContent: "center", borderRadius: "5px" }} className="heading">
          <Typography variant="h5">
            Industries(
            {industryCount ? parseInt(industryCount).toLocaleString() : "NA"})
          </Typography>
        </Box>

        {loading ? (
          <CircularProgress
            className="Loading"
            loading={"true"}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        ) : (
          <IndustriesTable pageNumber={page} />
        )}

        <Pagination
          sx={{
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "10px",
            paddingBottom: "10px",
            "Button.MuiPaginationItem-rounded.Mui-selected": {
              bgcolor: "rgb(35, 48, 68)",
              color: "rgb(238, 238, 238)",
            }
          }}
          count={parseInt(industryCount / 10) + (industryCount % 10 > 0 ? 1 : 0)}
          // onChange={(event, value) => setPage(value)}
          onChange={handlePageChange}
          shape="rounded"
          variant="outlined"
        />
      </Paper>
      <IndustriesView />
      <IndustryEdit/>
    </div>
  );
}
